import React from "react";
import { clsx } from "clsx";

export interface SpinnerProps extends React.HTMLAttributes<HTMLSpanElement> {
    size?: "sm" | "md" | "lg";
    label?: string;
}

const sizes = { sm: "h-4 w-4", md: "h-6 w-6", lg: "h-8 w-8" };

export const Spinner: React.FC<SpinnerProps> = ({ size = "md", label = "Loading", className, ...props }) => (
    <span
        role="status"
        aria-label={label}
        className={clsx("inline-flex text-primary", className)}
        {...props}
    >
        <svg className={clsx("animate-spin", sizes[size])} viewBox="0 0 24 24" fill="none" aria-hidden>
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
        </svg>
        <span className="sr-only">{label}</span>
    </span>
);
